import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import LogoIcon from "../../../../../css/WhiteLabelledDocuments/logo";
import TaxGuideStyles from "./TaxGuideStyles";
import Header from "./Header";
import Footer from "./Footer";
import { use } from "react";

const TaxGuide = ({
  primaryColor,
  logo,
  tradingName,
  regulatoryText,
  userEmail,
}) => {
  const styles = TaxGuideStyles(primaryColor || "081e56");
  const currentYear = 2025;
  const nextYear = 2026;
  return (
    <Document>
      <Page size={"A4"} orientation="landscape">
        <View style={styles.row}>
          <View
            style={{ ...styles.pageLeft, border: `5px solid #${primaryColor}` }}
          >
            <View style={styles.centeredContent}>
              {logo ? <Image style={styles.image} src={logo} /> : <LogoIcon />}
              <Text style={styles.subheading}>{tradingName}</Text>
              {/* <Text style={{ ...styles.subheading }}>
                damian@needingadvice.co.uk
              </Text> */}
              <Text style={{ ...styles.subheading }}>{userEmail}</Text>
              <Text style={{ ...styles.subheading }}>
                {new Date().toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                }) || ""}
              </Text>

              <View style={styles.graphicWrapper}>
                <View style={styles.graphicBox} />
                <View style={styles.graphicBox1} />
                <View style={styles.disclaimerTextContainer}>
                  <Text
                    style={{ ...styles.subheading, ...styles.disclaimerText }}
                  >
                    Tax Guide
                  </Text>
                  <Text
                    style={{ ...styles.subheading, ...styles.disclaimerText }}
                  >
                    {/* {currentYear}/{nextYear.toString().slice(-2)} */}
                    2026/27
                  </Text>
                  <Text style={styles.contentSmallItalic}>
                    This tax guide includes information for the 26/27 tax year
                    and the 25/26 tax year for comparison purposes. Please
                    consult with a qualified accountant before making any
                    decisions that could create a tax liability.
                  </Text>
                  <Text style={styles.contentSmallItalic}>
                    For the latest HMRC advisory fuel rates and notification of
                    charges please download the free CIPP payroll factapp
                    (search 'CIPP factapp').
                  </Text>
                  <Text style={styles.contentSmallItalic}>
                    This information regarding taxation represents a summary of
                    our understanding of the law at the date of its last review
                    (March 2026). Tax limits, benefits, allowances and rules are
                    often subject to change and may change in the future.
                    Advisers and individuals should check that tax limits,
                    allowances and rules have not changed. The value of benefits
                    depends on individual circumstances. Different options may
                    have different effects for tax purposes, different
                    implications for pension provision and different impacts on
                    other assets and financial planning.
                  </Text>
                </View>
              </View>
            </View>
          </View>
          <View
            style={{
              ...styles.pageCoverRight,
            }}
          >
            <View style={styles.graphicWrapper}>
              <View style={styles.graphicBox4} />
              <View style={styles.graphicBox5} />
              <View style={styles.graphicBox6} />
              <View style={styles.graphicBox7} />
              <View style={styles.graphicBox8} />
            </View>
            <Text style={styles.subheading}>Contents</Text>
            <View style={{ ...styles.row, gap: 20 }}>
              <View
                style={{
                  ...styles.column,
                  justifyContent: "left",
                  alignItems: "flex-start",
                }}
              >
                <Text style={styles.content}>Registered Pensions</Text>
                <Text style={styles.content}>State Pension</Text>
                <Text style={styles.content}>
                  National Insurance Contributions
                </Text>
                <Text style={styles.content}>Tax Incentivised Investments</Text>
                <Text style={styles.content}>Employment Allowance</Text>
                <Text style={styles.content}>
                  Stamp Duties and Property Transaction Taxes
                </Text>
                <Text style={styles.content}>Capital Gains Tax</Text>
                <Text style={styles.content}>Inheritance Tax</Text>
                <Text style={styles.content}>Social Security Benefits</Text>
                <Text style={styles.content}>Car Benefits</Text>
                <Text style={styles.content}>Vans - for Private Use</Text>
                <Text style={styles.content}>
                  Main Due Dates for Tax Payments
                </Text>
                <Text style={styles.content}>
                  Main Capital and Other Allowances
                </Text>
                <Text style={styles.content}>Corporation Tax</Text>
                <Text style={styles.content}>Value Added Tax</Text>

                <Text style={styles.content}>Income Tax</Text>
                <Text style={styles.content}>2026/27 Tax Calendar</Text>
              </View>
              <View
                style={{
                  ...styles.column,
                  justifyContent: "right",
                  alignItems: "flex-end",
                }}
              >
                <Text style={styles.content}>2</Text>
                <Text style={styles.content}>2</Text>
                <Text style={styles.content}>2</Text>
                <Text style={styles.content}>2</Text>
                <Text style={styles.content}>2</Text>
                <Text style={styles.content}>2 - 3</Text>
                <Text style={styles.content}>3</Text>
                <Text style={styles.content}>3</Text>
                <Text style={styles.content}>4</Text>
                <Text style={styles.content}>4</Text>
                <Text style={styles.content}>4</Text>
                <Text style={styles.content}>4</Text>
                <Text style={styles.content}>5</Text>
                <Text style={styles.content}>5</Text>
                <Text style={styles.content}>5</Text>
                <Text style={styles.content}>5</Text>
                <Text style={styles.content}>6</Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
      <Page style={styles.page} wrap size={"A4"} orientation="landscape">
        <Header primaryColor={primaryColor} tradingName={tradingName} />

        <Footer
          primaryColor={primaryColor}
          logo={logo}
          tradingName={tradingName}
          regulatoryText={regulatoryText}
          userEmail={userEmail}
        />
        <View
          style={{
            ...styles.row,
            alignItems: "flex-start",
            justifyContent: "left",
          }}
        >
          <View style={{ ...styles.pageLeft }}>
            <View style={styles.container}>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 4 }}>
                  <Text style={styles.subheading}>REGISTERED PENSIONS</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>
                    Lump sum and death benefit allowance
                  </Text>
                  <Text style={styles.contentSmall}>Lump sum allowance</Text>
                  <Text style={styles.contentSmall}>
                    Money purchase annual allowance
                  </Text>
                  <Text style={styles.contentSmall}>Annual allowance*</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>26/27</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£1,073,100</Text>
                  <Text style={styles.contentSmall}>£268,275</Text>
                  <Text style={styles.contentSmall}>£10,000</Text>
                  <Text style={styles.contentSmall}>£60,000</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>25/26</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£1,073,100</Text>
                  <Text style={styles.contentSmall}>£268,275</Text>
                  <Text style={styles.contentSmall}>£10,000</Text>
                  <Text style={styles.contentSmall}>£60,000</Text>
                </View>
              </View>
              {/* <View style={styles.smallSizedBox} /> */}
              <Text style={styles.contentSmall}>
                Annual allowance charge on excess is at applicable tax rate(s)
                on earnings
              </Text>
              <Text style={styles.contentSmallItalic}>
                *Reduced by £1 for every £2 of adjusted income over £260,000 to
                a minimum of £10,000, subject to threshold income being over
                £200,000
              </Text>
            </View>
            <View style={styles.container}>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 4 }}>
                  <Text style={styles.subheading}>STATE PENSION</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>New state pension</Text>
                  <Text style={styles.contentSmall}>
                    Basic state pension – single person*
                  </Text>
                  <Text style={styles.contentSmall}>
                    Basic state pension – spouse/civil partner*
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>Annual</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£12,547.60</Text>
                  <Text style={styles.contentSmall}>£9,614.80</Text>
                  <Text style={styles.contentSmall}>£5,759.00</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>Weekly</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£241.30</Text>
                  <Text style={styles.contentSmall}>£184.90</Text>
                  <Text style={styles.contentSmall}>££110.75</Text>
                </View>
              </View>
              {/* <View style={styles.smallSizedBox} /> */}
              <Text style={styles.contentSmallItalic}>
                *State pension age reached before or on 06/04/16
              </Text>
            </View>
            <View style={styles.container}>
              <View style={styles.containerRow}>
                <Text style={styles.subheading}>
                  NATIONAL INSURANCE CONTRIBUTIONS
                </Text>
                <Text style={styles.contentBold}>26/27</Text>
              </View>

              {/* <View style={styles.smallSizedBox} /> */}
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 3 }}>
                  <Text style={styles.contentBold}>Limits and thresholds</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>Lower earnings limit</Text>
                  <Text style={styles.contentSmall}>Primary threshold</Text>
                  <Text style={styles.contentSmall}>Secondary threshold</Text>
                  <Text style={styles.contentSmall}>
                    (and upper secondary thresholds)
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>Weekly</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£125</Text>
                  <Text style={styles.contentSmall}>£242</Text>
                  <Text style={styles.contentSmall}>£96</Text>
                  <Text style={styles.contentSmall}>£967</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>Monthly</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£542</Text>
                  <Text style={styles.contentSmall}>£1,048</Text>
                  <Text style={styles.contentSmall}>£417</Text>
                  <Text style={styles.contentSmall}>£4,189</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>Annual</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£6,500</Text>
                  <Text style={styles.contentSmall}>£12,570</Text>
                  <Text style={styles.contentSmall}>£5,000</Text>
                  <Text style={styles.contentSmall}>£50,270</Text>
                </View>
              </View>
              {/* <View style={styles.smallSizedBox} /> */}
              <Text style={styles.contentSmallItalic}>
                *No employer NICs on the first £967 pw for employees generally
                under 21 years, apprentices under 25 years and veterans in first
                12 months of civilian employment. No employer NICs on the first
                £481 pw for employees at freeports and investment zones in Great
                Britain in the first 36 months of employment
              </Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 4 }}>
                  <Text style={styles.contentBold}>Class 1</Text>
                  {/* <View style={styles.smallSizedBox} /> */}
                  <Text style={styles.contentSmall}>NICs rate</Text>
                  <Text style={styles.contentSmall}>
                    No NICs for employees generally on the first
                  </Text>
                  <Text style={styles.contentSmall}>
                    No NICs for younger employees* on the first
                  </Text>
                  <Text style={styles.contentSmall}>
                    NICs rate charged up to
                  </Text>
                  <Text style={styles.contentSmall}>
                    2% NICs on earnings over
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>Employee</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>8%</Text>
                  <Text style={styles.contentSmall}>£242 pw</Text>
                  <Text style={styles.contentSmall}>£242 pw</Text>
                  <Text style={styles.contentSmall}>£967 pw</Text>
                  <Text style={styles.contentSmall}>£967 pw</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>Employer</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>15%</Text>
                  <Text style={styles.contentSmall}>£96 pw</Text>
                  <Text style={styles.contentSmall}>£967 pw</Text>
                  <Text style={styles.contentSmall}>No limit</Text>
                  <Text style={styles.contentSmall}>N/A</Text>
                </View>
              </View>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Class 2 Self-employed</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentSmall}>
                    Flat rate per week (voluntary)
                  </Text>
                  <Text style={styles.contentSmall}>
                    Small profits threshold
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>£3.65</Text>
                  <Text style={styles.contentSmall}></Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>(£189.80 pa)</Text>
                  <Text style={styles.contentSmall}>£7,105</Text>
                </View>
              </View>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Class 3 Voluntary</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentSmall}>Flat rate per week</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>£18.40</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>(£956.80 pa)</Text>
                </View>
              </View>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Class 4 Self-employed</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentSmall}>on annual profits of </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={{ ...styles.contentSmall, textAlign: "left" }}>
                    £12,570 to £50,270
                  </Text>
                  <Text style={styles.contentSmall}>Over £50,270</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>6%</Text>
                  <Text
                    style={{ ...styles.contentSmall, color: "transparent" }}
                  >
                    .
                  </Text>
                  <Text style={styles.contentSmall}>2%</Text>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.verticleDivider} />
          <View style={{ ...styles.pageRight }}>
            <View style={styles.container}>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 4 }}>
                  <Text style={styles.subheading}>
                    TAX INCENTIVISED INVESTMENTS
                  </Text>
                  {/* <View style={styles.smallSizedBox} /> */}
                  <Text style={styles.contentSmall}>
                    Total Individual Savings Account (ISA) limit, excluding
                    Junior ISAs (JISAs)
                  </Text>
                  <Text style={styles.contentSmall}>Lifetime ISA</Text>
                  <Text style={styles.contentSmall}>JISA/Child Trust Fund</Text>
                  <Text style={styles.contentSmall}>
                    Venture Capital Trust (VCT) up to £200,000
                  </Text>
                  <Text style={styles.contentSmall}>
                    Enterprise Investment Scheme (EIS) at 30%*
                  </Text>
                  <Text style={styles.contentSmall}>
                    EIS eligible for CGT deferral relief
                  </Text>
                  <Text style={styles.contentSmall}>
                    Seed EIS (SEIS) at 50%
                  </Text>
                  <Text style={styles.contentSmall}>
                    SEIS CGT reinvestment relief
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>26/27</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£20,000</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>£4,000</Text>
                  <Text style={styles.contentSmall}>£9,000</Text>
                  <Text style={styles.contentSmall}>20%</Text>
                  <Text style={styles.contentSmall}>£2,000,000</Text>
                  <Text style={styles.contentSmall}>No limit</Text>
                  <Text style={styles.contentSmall}>£200,000</Text>
                  <Text style={styles.contentSmall}>50%</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>25/26</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£20,000</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>£4,000</Text>
                  <Text style={styles.contentSmall}>£9,000</Text>
                  <Text style={styles.contentSmall}>30%</Text>
                  <Text style={styles.contentSmall}>£2,000,000</Text>
                  <Text style={styles.contentSmall}>No limit</Text>
                  <Text style={styles.contentSmall}>£200,000</Text>
                  <Text style={styles.contentSmall}>50%</Text>
                </View>
              </View>
              {/* <View style={styles.verticleSizedBox} /> */}
              <Text style={styles.contentSmallItalic}>
                *Above £1,000,000 investment must be in knowledge-intensive
                companies
              </Text>
            </View>
            <View style={styles.container}>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 5.5 }}>
                  <Text style={styles.subheading}>EMPLOYMENT ALLOWANCE</Text>
                  <Text style={styles.contentSmall}>
                    Per business – not available if sole employee is a director
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>£10,500</Text>
                </View>
              </View>

              <View style={{ ...styles.containerColumn, width: "100%" }}>
                <Text style={styles.contentBold}>Class 1A Employer</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 5.5 }}>
                    <Text style={styles.contentSmall}>
                      On most employees’ and directors’ taxable benefits
                    </Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text
                      style={{ ...styles.contentSmall, alignItems: "flex-end" }}
                    >
                      15%
                    </Text>
                  </View>
                </View>
              </View>
              {/* <View style={styles.verticleSizedBox} /> */}
            </View>
            <View style={styles.container}>
              <Text style={styles.subheading}>
                STAMP DUTIES AND PROPERTY TRANSACTION TAXES
              </Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Stamp Duty and SDRT:</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={{ ...styles.contentSmall, textAlign: "left" }}>
                    Stocks and marketable securities
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>0.5%</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                </View>
              </View>
              <Text style={styles.contentSmallItalic}>
                *0% SDRT for transfers of newly UK listed securities from 27
                November 2025
              </Text>
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>
                  Additional residential and all corporate residential
                  properties
                </Text>
                <Text style={styles.contentSmall}>
                  £40,000 or more – add 5% to SDLT rates, 6% to LBTT rates and
                  4% to most LTT rates
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
      <Page style={styles.page} wrap size={"A4"} orientation="landscape">
        <Header primaryColor={primaryColor} tradingName={tradingName} />

        <Footer
          primaryColor={primaryColor}
          logo={logo}
          tradingName={tradingName}
          regulatoryText={regulatoryText}
          userEmail={userEmail}
        />
        <View
          style={{
            ...styles.row,
            alignItems: "flex-start",
            justifyContent: "left",
          }}
        >
          <View style={{ ...styles.pageLeft }}>
            <View style={styles.container}>
              <Text style={styles.subheading}>
                ENGLAND & N IRELAND – STAMP DUTY LAND TAX (SDLT) ON SLICES OF
                VALUE FROM 01/04/25
                {/* England & N Ireland – Stamp Duty Land Tax (SDLT) on slices of
                value from 01/04/25 */}
              </Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Residential property </Text>
                  <Text style={styles.contentSmall}>Up to £125,000</Text>
                  <Text style={styles.contentSmall}>£125,001 – £250,000 </Text>
                  <Text style={styles.contentSmall}>£250,001 – £925,000</Text>
                  <Text style={styles.contentSmall}>£925,001 – £1,500,000</Text>
                  <Text style={styles.contentSmall}>Over £1,500,000</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>%</Text>
                  <Text style={styles.contentSmall}>0</Text>
                  <Text style={styles.contentSmall}>2</Text>
                  <Text style={styles.contentSmall}>5</Text>
                  <Text style={styles.contentSmall}>10</Text>
                  <Text style={styles.contentSmall}>12</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Commercial property*</Text>
                  <Text style={styles.contentSmall}>Up to £150,000</Text>
                  <Text style={styles.contentSmall}>£150,001 – £250,000</Text>
                  <Text style={styles.contentSmall}>Over £250,000</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>%</Text>
                  <Text style={styles.contentSmall}>0</Text>
                  <Text style={styles.contentSmall}>2</Text>
                  <Text style={styles.contentSmall}>5</Text>
                </View>
              </View>
              <View style={styles.smallSizedBox} />
              <View
                style={{
                  ...styles.containerRow,
                  gap: 0,
                  justifyContent: "flex-start",
                }}
              >
                <Text style={styles.contentBold}>First time buyers: </Text>
                <Text style={styles.contentSmall}>
                  0% on first £300,000 for properties up to £500,000
                </Text>
              </View>
              <View
                style={{
                  ...styles.containerRow,
                  gap: 0,
                  justifyContent: "flex-start",
                }}
              >
                <Text style={styles.contentBold}>
                  Non-resident purchasers:{" "}
                </Text>
                <Text style={styles.contentSmall}>
                  2% surcharge on properties £40,000 or more
                </Text>
              </View>
              <View
                style={{
                  ...styles.containerColumn,
                }}
              >
                <Text style={styles.contentBold}>Residential properties</Text>
                <Text style={styles.contentSmall}>
                  bought by companies ect over £500,000: 17% of total
                  consideration, subject to certain exemptions
                </Text>
              </View>
              <Text style={styles.contentSmallItalic}>
                *0% for freeport and investment zone qualifying property in
                England only
              </Text>
            </View>
            <View style={styles.container}>
              <Text style={styles.subheading}>
                Scotland - Land and Buildings Transaction Tax (LBTT) on slices
                of value
              </Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Residential property </Text>
                  <Text style={styles.contentSmall}>Up to £145,000 </Text>
                  <Text style={styles.contentSmall}>£145,001–£250,000 </Text>
                  <Text style={styles.contentSmall}>£250,001–£325,000</Text>
                  <Text style={styles.contentSmall}>£325,001–£750,00</Text>
                  <Text style={styles.contentSmall}>Over £750,000 </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>%</Text>
                  <Text style={styles.contentSmall}>0</Text>
                  <Text style={styles.contentSmall}>2</Text>
                  <Text style={styles.contentSmall}>5</Text>
                  <Text style={styles.contentSmall}>10</Text>
                  <Text style={styles.contentSmall}>12</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Commercial property*</Text>
                  <Text style={styles.contentSmall}>Up to £150,000</Text>
                  <Text style={styles.contentSmall}>£150,001–£250,000</Text>
                  <Text style={styles.contentSmall}>Over £250,000</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>%</Text>
                  <Text style={styles.contentSmall}>0</Text>
                  <Text style={styles.contentSmall}>1</Text>
                  <Text style={styles.contentSmall}>5</Text>
                </View>
              </View>
              <View style={styles.smallSizedBox} />
              <View
                style={{
                  ...styles.containerRow,
                  gap: 0,
                  justifyContent: "flex-start",
                }}
              >
                <Text style={styles.contentBold}>First time buyers: </Text>
                <Text style={styles.contentSmall}>
                  0% on the first £175,000
                </Text>
              </View>
            </View>
            <View style={styles.container}>
              <Text style={styles.subheading}>
                Wales - Land Transaction Tax (LLT) on slices of value
              </Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Residential property </Text>
                  <Text style={styles.contentSmall}>Up to £225,000</Text>
                  <Text style={styles.contentSmall}>£225,001-£400,00</Text>
                  <Text style={styles.contentSmall}>£400,001–£750,000</Text>
                  <Text style={styles.contentSmall}>£750,001–£1,500,000 </Text>
                  <Text style={styles.contentSmall}>Over £1,500,000</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>%</Text>
                  <Text style={styles.contentSmall}>0</Text>
                  <Text style={styles.contentSmall}>6</Text>
                  <Text style={styles.contentSmall}>7.5</Text>
                  <Text style={styles.contentSmall}>10</Text>
                  <Text style={styles.contentSmall}>12</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Commercial property*</Text>
                  <Text style={styles.contentSmall}>Up to £225,000</Text>
                  <Text style={styles.contentSmall}>£225,001-£250,00</Text>
                  <Text style={styles.contentSmall}>£250,001–£1,000,000</Text>
                  <Text style={styles.contentSmall}>Over £1,000,000</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>%</Text>
                  <Text style={styles.contentSmall}>0</Text>
                  <Text style={styles.contentSmall}>1</Text>
                  <Text style={styles.contentSmall}>5</Text>
                  <Text style={styles.contentSmall}>6</Text>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.verticleDivider} />
          <View style={{ ...styles.pageRight }}>
            <View style={styles.container}>
              <Text style={styles.subheading}>CAPITAL GAINS TAX</Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>{"\u00A0"}</Text>
                  <Text style={styles.contentBold}>Annual exemption:</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>{"\u00A0"}</Text>

                  <Text style={styles.contentSmall}>
                    Individuals, estates, etc
                  </Text>
                  <Text style={styles.contentSmall}>Trusts generally</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>26/27</Text>
                  <Text style={styles.contentSmall}>£3,000 </Text>
                  <Text style={styles.contentSmall}>£1,500</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>25/26</Text>
                  <Text style={styles.contentSmall}>£3,000 </Text>
                  <Text style={styles.contentSmall}>£1,500</Text>
                </View>
              </View>
              <View style={styles.smallSizedBox} />
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  {/* <Text
                    style={{
                      ...styles.contentSmallBold,
                    }}
                  >
                    {"\u00A0"}
                  </Text> */}
                  <Text style={styles.contentBold}>
                    Below UK higher rate band
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  {/* <Text
                    style={{
                      ...styles.contentSmallBold,
                    }}
                  >
                    {"\u00A0"}
                  </Text> */}

                  <Text style={styles.contentSmall}>Tax rate</Text>
                  {/* <Text style={styles.contentSmall}>
                    Surcharge for residential property/carried interest*
                  </Text> */}
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  {/* <Text
                    style={{
                      ...styles.contentSmallBold,
                    }}
                  >
                    From 30/10/24
                  </Text> */}
                  <Text style={styles.contentSmall}>18%</Text>
                  {/* <Text style={styles.contentSmall}>0%/0%</Text> */}
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  {/* <Text
                    style={{
                      ...styles.contentSmallBold,
                    }}
                  >
                    To 29/10/25
                  </Text> */}
                  <Text style={styles.contentSmall}>18%</Text>
                  {/* <Text style={styles.contentSmall}>8%/8%</Text> */}
                </View>
              </View>
              {/* <View style={styles.smallSizedBox} /> */}
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>
                    Within UK higher and additional rate bands
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentSmall}>Tax rate</Text>
                  {/* <Text style={styles.contentSmall}>
                    Surcharge for residential property/carried interest*
                  </Text> */}
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>24%</Text>
                  {/* <Text style={styles.contentSmall}>0%/4%</Text> */}
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>24%</Text>
                  {/* <Text style={styles.contentSmall}>4%/8%</Text> */}
                </View>
              </View>
              {/* <View style={styles.smallSizedBox} /> */}
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>
                    Carried interest (all tax bands)s
                  </Text>
                  {/* <Text style={styles.contentSmallItalic}>
                    *For 25/26, rate for carried interest for all tax bands is
                    32%
                  </Text> */}
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentSmall}>Tax rate</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>NA</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>32%</Text>
                </View>
              </View>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>Trusts and estates</Text>
                  {/* <Text style={styles.contentSmallItalic}>
                    *For 25/26, rate for carried interest for all tax bands is
                    32%
                  </Text> */}
                </View>
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentSmall}>Tax rate</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>24%</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>24%</Text>
                </View>
              </View>
              {/* <View style={styles.smallSizedBox} /> */}
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>
                  Business Asset Disposal Relief
                </Text>
                <Text style={styles.contentSmall}>
                  18% (14% 25/26) on lifetime limit of £1,000,000 for trading
                  businesses and companies (minimum 5% participation) held for
                  at least 2 years.
                </Text>
              </View>
            </View>
            <View style={styles.container}>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 4 }}>
                  <Text style={styles.subheading}>INHERITANCE TAX</Text>
                  {/* <View style={styles.smallSizedBox} /> */}
                  <Text style={styles.contentSmall}>Nil-rate band*</Text>
                  <Text style={styles.contentSmall}>
                    Residence nil-rate band*†
                  </Text>
                  <Text style={styles.contentSmall}>Rate of tax on excess</Text>
                  <Text style={styles.contentSmall}>
                    Rate if at least 10% of net estate left to charity
                  </Text>
                  <Text style={styles.contentSmall}>
                    Lifetime transfers to and from certain trusts
                  </Text>
                  <Text style={styles.contentSmall}>
                    Overseas domiciled spouse/civil partner exemption
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>26/27</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£325,000</Text>
                  <Text style={styles.contentSmall}>£175,000</Text>
                  <Text style={styles.contentSmall}>40%</Text>
                  <Text style={styles.contentSmall}>36%</Text>
                  <Text style={styles.contentSmall}>20%</Text>
                  <Text style={styles.contentSmall}>£325,000</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>25/26</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£325,000</Text>
                  <Text style={styles.contentSmall}>£175,000</Text>
                  <Text style={styles.contentSmall}>40%</Text>
                  <Text style={styles.contentSmall}>36%</Text>
                  <Text style={styles.contentSmall}>20%</Text>
                  <Text style={styles.contentSmall}>£325,000</Text>
                </View>
              </View>
              <Text style={styles.contentSmallItalic}>
                *Up to 100% of the unused proportion of a deceased
                spouse’s/civil partner’s nil-rate band and/or residence nil-rate
                band can be claimed on the survivor’s death
              </Text>
              <Text style={styles.contentSmallItalic}>
                †Estates over £2,000,000: the value of the residence nil-rate
                band is reduced by 50% of the excess over £2,000,000
              </Text>
              <View style={styles.containerRow}>
                <View style={{ ...styles.containerColumn, flex: 0.5 }}>
                  <Text style={styles.contentSmallBold}>Reliefs</Text>
                  <Text style={styles.contentSmall}>26/27</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>25/26</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 3 }}>
                  <Text style={styles.contentSmallBold}>
                    Businesses, unlisted shares, some farms
                  </Text>
                  <Text style={styles.contentSmall}>
                    100% up to a maximum of £1,000,000,  with 50% thereafter*
                  </Text>
                  <Text style={styles.contentSmall}>100%</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmallBold}>AIM shares</Text>
                  <Text style={styles.contentSmall}>50%</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>100%</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1.5 }}>
                  <Text style={styles.contentSmallBold}>
                    Certain other assets
                  </Text>
                  <Text style={styles.contentSmall}>50%</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>50%</Text>
                </View>
              </View>
              {/* <View style={styles.containerColumn}>
                <Text style={styles.contentSmall}>
                  100% relief: businesses, unlisted/AIM companies, some
                  farmland/buildings.
                </Text>
                <Text style={styles.contentSmall}>
                  50% relief: certain other business assets.
                </Text>
              </View> */}
              <Text style={styles.contentSmallItalic}>
                *Transferable between spouses and civil partners
              </Text>
              <View style={styles.containerRow}>
                <Text style={styles.contentSmall}>Annual exempt gifts of:</Text>
                <Text style={styles.contentSmall}>£3,000 per donor</Text>
                <Text style={styles.contentSmall}>£250 per donee</Text>
              </View>
              <View style={styles.smallSizedBox} />
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>
                  Tapered tax charge on lifetime gifts between 3 and 7 years of
                  death
                </Text>
                <Text style={styles.contentSmall}>
                  Years 0–3 full 40% rate, then 8% less for each year until 0%
                  at 7 or more years.
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
      <Page style={styles.page} wrap size={"A4"} orientation="landscape">
        <Header primaryColor={primaryColor} tradingName={tradingName} />

        <Footer
          primaryColor={primaryColor}
          logo={logo}
          tradingName={tradingName}
          regulatoryText={regulatoryText}
          userEmail={userEmail}
        />
        <View
          style={{
            ...styles.row,
            alignItems: "flex-start",
            justifyContent: "left",
          }}
        >
          <View style={{ ...styles.pageLeft }}>
            <View style={styles.container}>
              <View style={styles.containerColumn}>
                <Text style={styles.subheading}>SOCIAL SECURITY BENEFITS</Text>
                <Text style={styles.contentSmallItalic}>
                  Weekly rates for 2026/27
                </Text>
              </View>
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>Statutory Pay Rates</Text>
                <Text style={styles.contentSmall}>
                  Based on minimum average earnings of at least £123.00 pw:
                </Text>
              </View>
              <View style={styles.containerRow}>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>Statutory Sick Pay</Text>
                  <Text style={styles.contentSmall}>
                    Statutory Maternity Pay/Statutory
                  </Text>
                  <Text style={styles.contentSmall}>Adoption Pay</Text>
                  <Text style={styles.contentSmall}>
                    Statutory Paternity Pay
                  </Text>
                  <Text style={styles.contentSmall}>Shared Parental Pay</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1.5 }}>
                  <Text style={styles.contentSmall}>£118.75 standard rate</Text>
                  <Text style={styles.contentSmall}>
                    First 6 weeks: 90% of average weekly pay
                  </Text>
                  <Text style={styles.contentSmall}>
                    Next 33 weeks: 90% of average weekly pay up to £118.75
                  </Text>
                  <Text style={styles.contentSmall}>
                    90% of average weekly pay up to £118.75
                  </Text>
                  <Text style={styles.contentSmall}>
                    Up to 37 weeks: 90% of average weekly pay up to £118.75
                  </Text>
                </View>
              </View>
              <View style={styles.smallSizedBox} />
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>
                  Child Benefit (see 'Income Tax – High Income Child Benefit
                  Charge')
                </Text>
              </View>
              <View style={styles.containerRow}>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>First or only child</Text>
                  <Text style={styles.contentSmall}>Each subsequent child</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1.5 }}>
                  <Text style={styles.contentSmall}>£27.05</Text>
                  <Text style={styles.contentSmall}>£17.90</Text>
                </View>
              </View>
              <View style={styles.smallSizedBox} />
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>Scottish Child Payment</Text>
              </View>
              <View style={styles.containerRow}>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>
                    For certain benefit claimants, per child under 16
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1.5 }}>
                  <Text style={styles.contentSmall}>£27.15 (from April)</Text>
                </View>
              </View>
              <View style={styles.smallSizedBox} />
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>
                  National Living Wage (NLW)/National Minimum Wage (NMW)
                </Text>
              </View>
              <View style={styles.containerRow}>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmallBold}>Year to 31/3/27</Text>
                  <Text style={styles.contentSmall}>Aged</Text>
                  <Text style={styles.contentSmall}>£/hour</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmallBold}>NLW</Text>
                  <Text style={styles.contentSmall}>21 and over</Text>
                  <Text style={styles.contentSmall}>£12.71</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmallBold}>NMW</Text>
                  <Text style={styles.contentSmall}>18–20</Text>
                  <Text style={styles.contentSmall}>£10.85</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1.5 }}>
                  <Text style={styles.contentSmallBold}>NMW</Text>
                  <Text style={styles.contentSmall}>Under 18/apprentice</Text>
                  <Text style={styles.contentSmall}>£8.00</Text>
                </View>
              </View>
            </View>
            <View style={styles.container}>
              <Text style={styles.subheading}>CAR BENEFITS</Text>
              <View
                style={{ ...styles.containerColumn, gap: 5, width: "100%" }}
              >
                <Text style={styles.contentSmall}>
                  Taxable amount based on original list price and CO2 emissions
                  in g/km.
                </Text>
                <Text style={styles.contentBold}>Zero emission cars 4%</Text>
                <Text style={styles.contentBold}>
                  Petrol and diesel hybrids with CO2 emissions 1–50g/km
                </Text>
                <View style={styles.containerRow}>
                  <View style={{ ...styles.containerColumn, flex: 6 }}>
                    <Text style={styles.contentBold}>
                      Range – electric-only miles
                    </Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>{"< 30"}</Text>
                    <Text style={styles.contentSmall}>16% </Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>30–39</Text>
                    <Text style={styles.contentSmall}>14%</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>40–69</Text>
                    <Text style={styles.contentSmall}>10% </Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>70–129</Text>
                    <Text style={styles.contentSmall}>7%</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>130+</Text>
                    <Text style={styles.contentSmall}>4%</Text>
                  </View>
                </View>
                <View style={{ ...styles.containerColumn, width: "100%" }}>
                  <View style={styles.containerRow}>
                    <View style={{ ...styles.containerColumn, flex: 2 }}>
                      <Text style={styles.contentBold}>
                        All non-diesel cars over 50g/km CO2
                      </Text>
                    </View>
                    <View style={{ ...styles.containerColumn, flex: 1 }}>
                      <Text style={styles.contentBold}>51–54 </Text>
                      <Text style={styles.contentSmall}>17%</Text>
                    </View>
                    <View style={{ ...styles.containerColumn, flex: 1 }}>
                      <Text style={styles.contentBold}>55 & over</Text>
                      <Text style={styles.contentSmall}>18%*–37%</Text>
                    </View>
                  </View>
                  <Text style={styles.contentSmallItalic}>
                    *Increased by 1% increments up to the maximum 37%
                  </Text>
                  <Text style={styles.content}>
                    Diesels not meeting RDE2: add 4% to non-diesel rates, up to
                    37%
                  </Text>
                </View>
                <View style={{ ...styles.containerRow }}>
                  <View style={{ ...styles.containerColumn, flex: 2 }}>
                    <Text style={styles.contentBold}>
                      Fuel benefit – taxable amount for private use
                    </Text>
                    <Text style={styles.contentSmall}>
                      CO2 % charge used for car benefit multiplied by
                    </Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>26/27</Text>
                    <Text style={styles.contentSmall}>£29,200.00</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>25/26</Text>
                    <Text style={styles.contentSmall}>£28,200.00</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.verticleDivider} />
          <View style={{ ...styles.pageRight }}>
            <View style={styles.container}>
              <Text style={styles.subheading}>VANS – FOR PRIVATE USE</Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentBold}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>
                    Zero emission: chargeable amount
                  </Text>
                  <Text style={styles.contentSmall}>
                    Other vans: chargeable amount
                  </Text>
                  <Text style={styles.contentSmall}>
                    Fuel: chargeable amount
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>26/27</Text>
                  <Text style={styles.contentSmall}>Nil</Text>
                  <Text style={styles.contentSmall}>£4,170.00</Text>
                  <Text style={styles.contentSmall}>£798.00</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentBold}>25/26</Text>
                  <Text style={styles.contentSmall}>Nil</Text>
                  <Text style={styles.contentSmall}>£4,020.00</Text>
                  <Text style={styles.contentSmall}>£769.00</Text>
                </View>
              </View>
              <View style={styles.verticleSizedBox} />
              <Text style={styles.contentBold}>
                TAX-FREE BUSINESS MILEAGE ALLOWANCE – OWN VEHICLE
              </Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentSmall}>
                    Cars and vans first 10,000 miles
                  </Text>
                  <Text style={styles.contentSmall}>Qualifying passenger</Text>
                  <Text style={styles.contentSmall}>Motorcycles</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>45p per mile</Text>
                  <Text style={styles.contentSmall}>5p per mile</Text>
                  <Text style={styles.contentSmall}>24p per mile</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmall}>then 25p per mile</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>Bicycles 20p per mile</Text>
                </View>
              </View>
            </View>
            <View style={styles.container}>
              <View style={styles.containerColumn}>
                <Text style={styles.subheading}>
                  MAIN DUE DATES FOR TAX PAYMENTS
                </Text>
                <Text style={styles.contentBold}>
                  Income tax, NICs and capital gains tax – Self-assessment
                </Text>
              </View>

              <View style={styles.containerRow}>
                <View style={{ ...styles.containerColumn, flex: 5 }}>
                  <Text style={styles.contentSmall}>31 Jan in tax year</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>Following 31 July</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>Following 31 Jan</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1, gap: 0 }}>
                  <Text style={{ ...styles.contentSmall, fontSize: 15 }}>
                    {"]"}
                  </Text>
                  <Text style={{ ...styles.contentSmall, fontSize: 15 }}>
                    {"]"}
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 20 }}>
                  <Text style={styles.contentSmall}>
                    Normally 50% of previous year’s income tax (less tax
                    deducted at source) and class 4 NICs
                  </Text>
                  <View style={{ ...styles.smallSizedBox, height: 5 }} />
                  <Text style={styles.contentSmall}>
                    Balance of income tax, class 4 NICs and CGT, plus class 2
                    NICs paid voluntarily
                  </Text>
                </View>
              </View>
              <View style={styles.smallSizedBox} />
              <Text style={styles.contentBold}>Inheritance tax</Text>
              <View style={styles.containerRow}>
                <View style={{ ...styles.containerColumn }}>
                  <Text style={styles.contentSmall}>On death:</Text>
                  <Text style={styles.contentSmall}>
                    Lifetime transfer 6 April–30 September:
                  </Text>
                  <Text style={styles.contentSmall}>
                    Lifetime transfer 1 October–5 April:
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn }}>
                  <Text style={styles.contentSmall}>
                    Normally 6 months after end of month of death
                  </Text>
                  <Text style={styles.contentSmall}>
                    30 April in following year
                  </Text>
                  <Text style={styles.contentSmall}>
                    6 months after end of month of transfer
                  </Text>
                </View>
              </View>
              <View style={styles.smallSizedBox} />
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>
                  Capital gains tax – residential UK property
                </Text>
                <Text style={styles.contentSmall}>
                  Report and pay within 60 days of completion of conveyance of
                  the property
                </Text>
              </View>
              <View style={styles.smallSizedBox} />
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>
                  Corporation tax – Self-assessment
                </Text>
                <Text style={styles.contentSmall}>
                  • Profits under £1,500,000: 9 months + 1 day after end of
                  accounting period
                </Text>
                <Text style={styles.contentSmall}>
                  • Profits £1,500,000–£20,000,000: normally payable in 7th,
                  10th, 13th and 16th months after start of the accounting
                </Text>
                <Text style={styles.contentSmall}>
                  • Profits over £20,000,000: normally payable in 3rd, 6th, 9th
                  and 12th months after start of the accounting period
                </Text>
                <Text style={styles.contentSmall}>
                  • Growing companies: no instalments where profits are
                  £10,000,000 or less and the company was not a large company
                  for the previous year
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
      <Page style={styles.page} wrap size={"A4"} orientation="landscape">
        <Header primaryColor={primaryColor} tradingName={tradingName} />

        <Footer
          primaryColor={primaryColor}
          logo={logo}
          tradingName={tradingName}
          regulatoryText={regulatoryText}
          userEmail={userEmail}
        />
        <View
          style={{
            ...styles.row,
            alignItems: "flex-start",
            justifyContent: "left",
          }}
        >
          <View style={{ ...styles.pageLeft }}>
            <View style={styles.container}>
              <Text style={styles.subheading}>
                MAIN CAPITAL AND OTHER ALLOWANCES
              </Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 6 }}>
                  <Text style={styles.contentSmall}>
                    Plant & machinery (P&M) 100% annual investment allowance
                    (1st year)
                  </Text>
                  <Text style={styles.contentSmall}>
                    P&M allowance for companies (1st year)*
                  </Text>
                  <Text style={styles.contentSmall}>
                    Special rate P&M allowance for companies (1st year)*
                  </Text>
                  <Text style={styles.contentSmall}>
                    P&M allowance for unincorporated businesses (1st year) from
                    1 January 2026*
                  </Text>
                  <Text style={styles.contentSmall}>P&M**</Text>
                  <Text style={styles.contentSmall}>
                    Patent rights and know-how**
                  </Text>
                  <Text style={styles.contentSmall}>
                    Special rate P&M e.g. long-life assets and integral features
                    of buildings**
                  </Text>
                  <Text style={styles.contentSmall}>
                    Structures and buildings (straight line)†
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 0.8 }}>
                  <Text style={styles.contentSmall}>£1,000,000</Text>
                  <Text style={styles.contentSmall}>100%</Text>
                  <Text style={styles.contentSmall}>50%</Text>
                  <Text style={styles.contentSmall}>40%</Text>
                  <Text style={styles.contentSmall}>14%</Text>
                  <Text style={styles.contentSmall}>25%</Text>
                  <Text style={styles.contentSmall}>6%</Text>
                  <Text style={styles.contentSmall}>3%</Text>
                </View>
              </View>
              {/* <View style={styles.smallSizedBox} /> */}
              <Text style={styles.contentBold}>Motor cars</Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn }}>
                  <Text style={styles.contentSmall}>
                    CO2 emissions of g/km:
                  </Text>
                  <Text style={styles.contentSmall}>Capital allowance: </Text>
                </View>
                <View style={{ ...styles.containerColumn }}>
                  <Text style={styles.contentSmall}>0* </Text>
                  <Text style={styles.contentSmall}>100% first year</Text>
                </View>
                <View style={{ ...styles.containerColumn }}>
                  <Text style={styles.contentSmall}>1–50</Text>
                  <Text style={styles.contentSmall}>18% pa** </Text>
                </View>
                <View style={{ ...styles.containerColumn }}>
                  <Text style={styles.contentSmall}>Over 50</Text>
                  <Text style={styles.contentSmall}>6% pa**</Text>
                </View>
              </View>
              <View style={styles.containerColumn}>
                <Text style={styles.contentSmallItalic}>
                  *New and unused only **Annual reducing balance
                </Text>
                <Text style={styles.contentSmallItalic}>
                  †10% for freeports & investment zones in Great Britain
                </Text>
              </View>
            </View>
            <View style={styles.container}>
              <Text style={styles.subheading}>CORPORATION TAX</Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View
                  style={{
                    ...styles.column,
                    flex: 3.5,
                    alignItems: "left",
                  }}
                >
                  <Text style={{ ...styles.contentBold, textAlign: "left" }}>
                    Year to 31/3/27 and 31/3/26
                  </Text>
                  <View style={styles.smallSizedBox} />
                  <View style={styles.verticleSizedBox} />
                  <View style={styles.verticleSizedBox} />
                  {/* <View style={styles.smallSizedBox} /> */}
                  <Text style={{ ...styles.contentSmall, textAlign: "left" }}>
                    Loans to participators
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 3 }}>
                  <Text style={styles.contentBold}>Profits</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>£0 - £50,000</Text>
                  <Text style={styles.contentSmall}>£50,001 - £250,000</Text>
                  <Text style={styles.contentSmall}>£250,001 and above</Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 3 }}>
                  <Text style={styles.contentBold}>Effective rate</Text>
                  <View style={styles.smallSizedBox} />
                  <Text style={styles.contentSmall}>19.0%</Text>
                  <Text style={styles.contentSmall}>26.5%</Text>
                  <Text style={styles.contentSmall}>25.0%</Text>
                  <Text style={styles.contentSmall}>33.75%</Text>
                </View>
                <Text
                  style={{
                    ...styles.contentSmall,
                    fontSize: 36,
                    fontWeight: "100",
                    // lineHeight: 42,
                    marginTop: 10,
                  }}
                >
                  {"}"}
                </Text>
                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 2,
                    justifyContent: "center",
                  }}
                >
                  <Text style={{ ...styles.contentBold, textAlign: "left" }}>
                    Diverted profits
                  </Text>
                  <View style={{ ...styles.verticleSizedBox, height: 10 }} />
                  <Text style={styles.contentSmall}>31%</Text>
                </View>
              </View>
            </View>
            <View style={styles.container}>
              <Text style={styles.subheading}>VALUE ADDED TAX</Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 2 }}>
                  <Text style={styles.contentSmall}>Standard rate </Text>
                  <Text style={styles.contentSmall}>Domestic fuel </Text>
                  <Text style={styles.contentSmall}>
                    Installation of energy saving materials (except Northern
                    Ireland)
                  </Text>
                  <Text style={styles.contentSmall}>
                    Registration level £90,000
                  </Text>
                  <Text style={styles.contentSmall}>
                    Flat rate scheme turnover limit
                  </Text>
                  <Text style={styles.contentSmall}>
                    Cash and annual accounting schemes turnover limit
                  </Text>
                </View>

                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 1,
                  }}
                >
                  <Text style={styles.contentSmall}>20%</Text>
                  <Text style={styles.contentSmall}>5%</Text>
                  <Text style={styles.contentSmall}>0%</Text>
                  <Text style={styles.contentSmall}>
                    Deregistration £88,000
                  </Text>
                  <Text style={styles.contentSmall}>£150,000</Text>
                  <Text style={styles.contentSmall}>£1,350,000</Text>
                </View>
              </View>
            </View>

            {/* <View style={styles.container}>
              <Text style={styles.subheading}>CAR BENEFITS</Text>
              <View
                style={{ ...styles.containerColumn, gap: 5, width: "100%" }}
              >
                <Text style={styles.contentSmall}>
                  Taxable amount based on original list price and CO2 emissions
                  in g/km.
                </Text>
                <Text style={styles.contentBold}>Zero emission cars 4%</Text>
                <Text style={styles.contentBold}>
                  Petrol and diesel hybrids with CO2 emissions 1–50g/km
                </Text>
                <View style={styles.containerRow}>
                  <View style={{ ...styles.containerColumn, flex: 6 }}>
                    <Text style={styles.contentBold}>
                      Range – electric-only miles
                    </Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>{"< 30"}</Text>
                    <Text style={styles.contentSmall}>16% </Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>30–39</Text>
                    <Text style={styles.contentSmall}>14%</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>40–69</Text>
                    <Text style={styles.contentSmall}>10% </Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>70–129</Text>
                    <Text style={styles.contentSmall}>7%</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>130+</Text>
                    <Text style={styles.contentSmall}>4%</Text>
                  </View>
                </View>
                <View style={{ ...styles.containerColumn, width: "100%" }}>
                  <View style={styles.containerRow}>
                    <View style={{ ...styles.containerColumn, flex: 2 }}>
                      <Text style={styles.contentBold}>
                        All non-diesel cars over 50g/km CO2
                      </Text>
                    </View>
                    <View style={{ ...styles.containerColumn, flex: 1 }}>
                      <Text style={styles.contentBold}>51–54 </Text>
                      <Text style={styles.contentSmall}>17%</Text>
                    </View>
                    <View style={{ ...styles.containerColumn, flex: 1 }}>
                      <Text style={styles.contentBold}>55 & over</Text>
                      <Text style={styles.contentSmall}>18%*–37%</Text>
                    </View>
                  </View>
                  <Text style={styles.contentSmallItalic}>
                    *Increased by 1% increments up to the maximum 37%
                  </Text>
                  <Text style={styles.content}>
                    Diesels not meeting RDE2: add 4% to non-diesel rates, up to
                    37%
                  </Text>
                </View>
                <View style={{ ...styles.containerRow }}>
                  <View style={{ ...styles.containerColumn, flex: 2 }}>
                    <Text style={styles.contentBold}>
                      Fuel benefit – taxable amount for private use
                    </Text>
                    <Text style={styles.contentSmall}>
                      CO2 % charge used for car benefit multiplied by
                    </Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>26/27</Text>
                    <Text style={styles.contentSmall}>£29,200.00</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentBold}>25/26</Text>
                    <Text style={styles.contentSmall}>£28,200.00</Text>
                  </View>
                </View>
              </View>
            </View> */}
          </View>
          <View style={styles.verticleDivider} />
          <View style={{ ...styles.pageRight }}>
            <View style={styles.container}>
              <Text style={styles.subheading}>INCOME TAX</Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 5 }}>
                  <Text style={{ ...styles.contentBold, textAlign: "left" }}>
                    Main personal allowances and reliefs
                  </Text>
                  <Text style={styles.contentSmall}>Personal allowance*</Text>
                  <Text style={styles.contentSmall}>
                    Marriage/civil partners’ transferable allowance
                  </Text>
                  <Text style={styles.contentSmall}>
                    Blind person’s allowance
                  </Text>
                  <Text style={styles.contentSmall}>Rent-a-room relief</Text>
                  <Text style={styles.contentSmall}>
                    Property allowance and trading allowance (each)
                  </Text>
                </View>
                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 1,
                  }}
                >
                  <Text style={styles.contentBold}>26/27</Text>
                  <Text style={styles.contentSmall}>£12,570</Text>
                  <Text style={styles.contentSmall}>£1,260</Text>
                  <Text style={styles.contentSmall}>£3,250</Text>
                  <Text style={styles.contentSmall}>£7,500</Text>
                  <Text style={styles.contentSmall}>£1,000</Text>
                </View>

                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 1,
                  }}
                >
                  <Text style={styles.contentBold}>25/26</Text>
                  <Text style={styles.contentSmall}>£12,570</Text>
                  <Text style={styles.contentSmall}>£1,260</Text>
                  <Text style={styles.contentSmall}>£3,130</Text>
                  <Text style={styles.contentSmall}>£7,500</Text>
                  <Text style={styles.contentSmall}>£1,000</Text>
                </View>
              </View>
              <Text style={styles.contentSmallItalic}>
                *Personal allowance reduced by £1 for every £2 of adjusted net
                income over £100,000
              </Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 5 }}>
                  <Text style={{ ...styles.contentBold, textAlign: "left" }}>
                    UK taxpayers excluding Scottish taxpayers’ 26/27 25/26
                    non-dividend, non-savings income
                  </Text>
                  <Text style={styles.contentSmall}>
                    20% basic rate on taxable income up to
                  </Text>
                  <Text style={styles.contentSmall}>
                    40% higher rate on next slice of income over
                  </Text>
                  <Text style={styles.contentSmall}>
                    45% additional rate on income over
                  </Text>
                </View>
                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 1,
                  }}
                >
                  <Text style={styles.contentBold}>26/27</Text>
                  <Text style={styles.contentBold}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>£37,700</Text>
                  <Text style={styles.contentSmall}>£37,700</Text>
                  <Text style={styles.contentSmall}>£125,140</Text>
                </View>

                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 1,
                  }}
                >
                  <Text style={styles.contentBold}>25/26</Text>
                  <Text style={styles.contentBold}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>£37,700 </Text>
                  <Text style={styles.contentSmall}>£37,700</Text>
                  <Text style={styles.contentSmall}>£125,140</Text>
                </View>
              </View>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 5 }}>
                  <Text style={{ ...styles.contentBold, textAlign: "left" }}>
                    Scottish taxpayers – non-dividend, non-savings income*
                  </Text>
                  <Text style={styles.contentSmall}>
                    19% starter rate on taxable income up to
                  </Text>
                  <Text style={styles.contentSmall}>
                    20% basic rate on next slice up to
                  </Text>
                  <Text style={styles.contentSmall}>
                    21% intermediate rate on next slice up to
                  </Text>
                  <Text style={styles.contentSmall}>
                    42% higher rate on next slice up to
                  </Text>
                  <Text style={styles.contentSmall}>
                    45% advanced rate on next slice up to
                  </Text>
                  <Text style={styles.contentSmall}>
                    48% top rate on income over
                  </Text>
                </View>
                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 1,
                  }}
                >
                  <Text style={styles.contentBold}>26/27</Text>
                  <Text style={styles.contentBold}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>£16,537</Text>
                  <Text style={styles.contentSmall}>£29,526</Text>
                  <Text style={styles.contentSmall}>£43,662</Text>
                  <Text style={styles.contentSmall}>£75,000</Text>
                  <Text style={styles.contentSmall}>£125,140</Text>
                  <Text style={styles.contentSmall}>£125,140</Text>
                </View>
                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 1,
                  }}
                >
                  <Text style={styles.contentBold}>25/26</Text>
                  <Text style={styles.contentBold}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>£15,397</Text>
                  <Text style={styles.contentSmall}>£27,491</Text>
                  <Text style={styles.contentSmall}>£43,662</Text>
                  <Text style={styles.contentSmall}>£75,000</Text>
                  <Text style={styles.contentSmall}>£125,140</Text>
                  <Text style={styles.contentSmall}>£125,140</Text>
                </View>
              </View>
              <View style={{ ...styles.column, width: "100%", gap: 0 }}>
                <Text style={styles.contentSmallItalic}>
                  *Assumes individuals are in receipt of the Standard UK
                  Personal Allowance{"\n"} *Those earning more than £100,000
                  will see their Personal Allowance reduced by £1 for every £2
                  earned over £100,000. +{"\n"}The above motion will be debated
                  by the Scottish Parliament and, if passed, will give effect to
                  the Scottish Government’s Income Tax policy for 2025-26.
                </Text>
              </View>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 5 }}>
                  <Text style={{ ...styles.contentBold, textAlign: "left" }}>
                    All UK taxpayers
                  </Text>
                  <Text style={styles.contentSmall}>
                    Starting rate at 0% on band of savings income up to**
                  </Text>
                  <Text style={styles.contentSmall}>
                    Personal savings allowance at 0%:
                  </Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>
                    Dividend allowance at 0%: All individuals
                  </Text>
                  <Text style={styles.contentSmall}>
                    Tax rates on dividend income:
                  </Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>
                    Trusts: Income exemption generally
                  </Text>
                  <Text style={styles.contentSmall}>
                    Rate applicable to trusts:
                  </Text>
                </View>
                <View style={{ ...styles.containerColumn, flex: 1.5 }}>
                  <Text style={{ ...styles.contentBold, textAlign: "left" }}>
                    {"\u00A0"}
                  </Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>Basic rate</Text>
                  <Text style={styles.contentSmall}>Higher rate</Text>
                  <Text style={styles.contentSmall}>Additional rate</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>Basic rate</Text>
                  <Text style={styles.contentSmall}>Higher rate</Text>
                  <Text style={styles.contentSmall}>Additional rate</Text>
                  <Text style={styles.contentSmall}>{"\u00A0"}</Text>
                  <Text style={styles.contentSmall}>Dividends</Text>
                  <Text style={styles.contentSmall}>Other Income</Text>
                </View>
                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 1,
                  }}
                >
                  <Text style={styles.contentBold}>26/27</Text>
                  <Text style={styles.contentSmall}>£5,000</Text>
                  <Text style={styles.contentSmall}>£1,000</Text>
                  <Text style={styles.contentSmall}>£500</Text>
                  <Text style={styles.contentSmall}>£0</Text>
                  <Text style={styles.contentSmall}>£500</Text>
                  <Text style={styles.contentSmall}>10.75%</Text>
                  <Text style={styles.contentSmall}>35.75%</Text>
                  <Text style={styles.contentSmall}>39.35%</Text>
                  <Text style={styles.contentSmall}>£500</Text>
                  <Text style={styles.contentSmall}>39.35%</Text>
                  <Text style={styles.contentSmall}>45%</Text>
                </View>

                <View
                  style={{
                    ...styles.containerColumn,
                    flex: 1,
                  }}
                >
                  <Text style={styles.contentBold}>25/26</Text>
                  <Text style={styles.contentSmall}>£5,000</Text>
                  <Text style={styles.contentSmall}>£1,000</Text>
                  <Text style={styles.contentSmall}>£500</Text>
                  <Text style={styles.contentSmall}>£0</Text>
                  <Text style={styles.contentSmall}>£500</Text>
                  <Text style={styles.contentSmall}>8.75%</Text>
                  <Text style={styles.contentSmall}>33.75% </Text>
                  <Text style={styles.contentSmall}>39.35% </Text>
                  <Text style={styles.contentSmall}>£500</Text>
                  <Text style={styles.contentSmall}>39.35% </Text>
                  <Text style={styles.contentSmall}>45% </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </Page>
      <Page style={styles.page} wrap size={"A4"} orientation="landscape">
        <Header primaryColor={primaryColor} tradingName={tradingName} />

        <Footer
          primaryColor={primaryColor}
          logo={logo}
          tradingName={tradingName}
          regulatoryText={regulatoryText}
          userEmail={userEmail}
        />
        <View
          style={{
            ...styles.row,
            alignItems: "flex-start",
            justifyContent: "left",
          }}
        >
          <View style={{ ...styles.pageLeft }}>
            <View style={styles.container}>
              <Text style={styles.subheading}>2026/27 TAX CALENDAR</Text>
              <Text style={styles.contentSmallItalic}>
                Make payment on the previous working day where the due date
                falls on a weekend/bank holiday.
              </Text>
              <Text style={styles.contentBold}>Every month</Text>
              <View
                style={{
                  ...styles.containerRow,
                }}
              >
                <View style={{ ...styles.containerColumn, flex: 1 }}>
                  <Text style={styles.contentSmallBold}>19</Text>
                  <View style={{ ...styles.smallSizedBox }} />
                  <View style={{ ...styles.smallSizedBox }} />
                  <Text style={styles.contentSmallBold}>22</Text>
                </View>
                <View style={styles.verticleSizedBox} />
                <View style={{ ...styles.containerColumn, flex: 15 }}>
                  <Text style={styles.contentSmall}>
                    Submit CIS contractors’ monthly return.
                  </Text>
                  <View style={{ ...styles.smallSizedBox }} />
                  <Text style={styles.contentSmall}>
                    PAYE/NICs/CIS deductions paid electronically for period
                    ending 5th of the month {"\n"}(19th if not paying
                    electronically).
                  </Text>
                </View>
              </View>
              <View style={styles.smallSizedBox} />
              <View style={styles.containerColumn}>
                <Text style={styles.contentBold}>Month end</Text>
                <Text style={styles.contentSmall}>
                  Submit CT600 for year ending 12 months previously
                </Text>
                <Text style={styles.contentSmall}>
                  Last day to amend CT600 for year ending 24 months previously
                </Text>
              </View>
              <View style={styles.verticleSizedBox} />
              <View
                style={{
                  ...styles.column,
                  gap: 0,
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <Text style={styles.contentBold}>April 2026</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <View style={{ ...styles.smallSizedBox, height: 2 }} />
                    {/* <Text style={styles.contentSmallBold}>1</Text>
                    <View style={{ ...styles.smallSizedBox }} />
                    <View style={{ ...styles.verticleSizedBox }} />
                    <View style={{ ...styles.verticleSizedBox }} /> */}
                    <Text style={styles.contentSmallBold}>6</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 15 }}>
                    {/* <Text style={styles.contentSmall}>
                      Residential SDLT threshold reverts to £125,000 with 2%
                      rate then applying up to £250,000. First time-buyer
                      thresholds reduced by £125,000. SDLT on additional
                      residential properties surcharge increased by 2%.
                    </Text> */}
                    <Text style={styles.contentSmall}>
                      Basic and higher rate tax on dividend income increased by
                      2%. Venture capital trust income tax relief reduced to
                      20%. New 40% first year capital allowance for
                      unincorporated businesses. CGT business asset disposal
                      relief rate increased to 18%. National minimum wage rates
                      rise. Making Tax Digital for Income Tax SelfAssessment
                      starts for self-employed workers and landlords with
                      qualifying income over £50,000.
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  ...styles.column,
                  gap: 0,
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <Text style={styles.contentBold}>July 2026</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentSmallBold}>5</Text>
                    <View style={{ height: 5 }} />
                    <Text style={styles.contentSmallBold}>6</Text>
                    <View style={{ height: 12 }} />
                    <Text style={styles.contentSmallBold}>22</Text>
                    <View style={{ height: 2 }} />
                    <Text style={styles.contentSmallBold}>31</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 15, gap: 0 }}>
                    <Text style={styles.contentSmall}>
                      Last date to agree a new PAYE Settlement Agreement (PSA)
                      for 2025/26.
                    </Text>
                    <Text style={styles.contentSmall}>
                      Deadline for employers to submit forms P11D (expenses) and
                      P11D (b) (benefits) for 2025/26 to HMRC and provide copies
                      to employees.
                    </Text>
                    <Text style={styles.contentSmall}>
                      Pay class 1A NICs (19 July if not paying electronically).
                    </Text>
                    <Text style={styles.contentSmall}>
                      Second payment on account for 2025/26 income tax and class
                      4 NICs.
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  ...styles.column,
                  gap: 0,
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <Text style={styles.contentBold}>August 2026</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <View style={{ ...styles.smallSizedBox, height: 2 }} />
                    <Text style={styles.contentSmallBold}>1</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 15 }}>
                    <Text style={styles.contentSmall}>
                      Penalty of 5% of the tax due or £300, whichever is the
                      greater, where the 2024/25 tax return has not been filed.
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  ...styles.column,
                  gap: 0,
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <Text style={styles.contentBold}>October 2026</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 1, gap: 3 }}>
                    <Text style={styles.contentSmallBold}>5</Text>
                    <Text style={styles.contentSmallBold}>22</Text>
                    <Text style={styles.contentSmallBold}>31</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 15 }}>
                    <Text style={styles.contentSmall}>
                      Deadline to register for self-assessment for 2025/26.
                    </Text>
                    <Text style={styles.contentSmall}>
                      Pay tax and class 1B NICs on PSAs (19th if not paying
                      electronically).
                    </Text>
                    <Text style={styles.contentSmall}>
                      Deadline for 2025/26 tax return if filed on paper.
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  ...styles.column,
                  gap: 0,
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <Text style={styles.contentBold}>December 2026</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentSmallBold}>30</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 15 }}>
                    <Text style={styles.contentSmall}>
                      Deadline to submit 2025/26 tax return online to have
                      underpaid PAYE tax collected through the 27/28 tax code.
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={styles.verticleDivider} />
          <View style={{ ...styles.pageRight }}>
            <View style={styles.graphicWrapper}>
              <View style={styles.graphicBox4} />
              <View style={styles.graphicBox5} />
              <View style={styles.graphicBox6} />
              <View style={styles.graphicBox7} />
              <View style={styles.graphicBox8} />
            </View>
            <View style={{ ...styles.container, gap: 0 }}>
              <View
                style={{
                  ...styles.column,
                  gap: 0,
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <Text style={styles.contentBold}>January 2027</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentSmallBold}>31</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 15 }}>
                    <Text style={styles.contentSmall}>
                      Submit 2025/26 self-assessment tax return online. Pay
                      balance of 2025/26 income tax, class 4 NICs, CGT, class 2
                      NICs paid voluntarily plus first payment on account for
                      2026/27 income tax and class 4 NICs.
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  ...styles.column,
                  gap: 0,
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <Text style={styles.contentBold}>February 2027</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentSmallBold}>1</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 15 }}>
                    <Text style={styles.contentSmall}>
                      Initial penalty imposed where the 2025/26 tax return has
                      not been filed or has been filed on paper after 31 October
                      2026.
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  ...styles.column,
                  gap: 0,
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <Text style={styles.contentBold}>March 2027</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentSmallBold}>3</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 15 }}>
                    <Text style={styles.contentSmall}>
                      First 5% penalty imposed on 2025/26 tax unpaid on 3 March.
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  ...styles.column,
                  gap: 0,
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <Text style={styles.contentBold}>April 2027</Text>
                <View
                  style={{
                    ...styles.containerRow,
                  }}
                >
                  <View style={{ ...styles.containerColumn, flex: 1 }}>
                    <Text style={styles.contentSmallBold}>6</Text>
                  </View>
                  <View style={{ ...styles.containerColumn, flex: 15 }}>
                    <Text style={styles.contentSmall}>
                      Income tax increased by 2% across all tax bands on
                      property and savings income. ISA cash limit reduced to
                      £12,000 for people under 65. Qualifying income for Making
                      Tax Digital for Income Tax reduced to £30,000.
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default TaxGuide;
